import studyBrowserSection from "./studyBrowserSection";
export { studyBrowserSection as default };
